import styled, { css } from 'styled-components';
import { Radio } from '@prisjakt/ui-inputs';
import { layout, media } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';
import { SharedListItemStyles } from '@prisjakt/ui-dropdown-new/src/item';

import GroupIcon from 'mdi-react/SortVariantIcon';
import SortIcon from 'mdi-react/SortDescendingIcon';

export const SortingOptions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  z-index: 2;
  ${media.mediumDown`
    margin-right: auto;
  `};
  & + & {
    margin-left: ${layout.spacing.small};
  }
`;

export const SortingOptionsButton = styled(Button)`
  padding: 0;
  white-space: nowrap;
`;

type ButtonTextProps = {
  hide?: boolean;
};

export const ButtonText = styled.span<ButtonTextProps>(
  props => css`
    ${props.hide &&
      css`
        display: none;
      `}
  `
);
type RadioItemProps = {
  current: boolean;
};

export const OnlyMobile = styled.span`
  display: none;

  ${media.smallOnly`
    display: inherit;
  `}
`;

export const Label = styled.span`
  white-space: nowrap;
  margin-right: ${layout.spacing.xxSmall};
  ${media.smallOnly`
    display: none;
  `}
`;

export const TabletDesktop = styled.span`
  display: flex;
  align-items: center;

  ${media.smallOnly`
    display: none;
  `}
`;

export const RadioItem = styled(Radio)<RadioItemProps>(
  props => css`
    ${SharedListItemStyles};
    min-width: 140px;

    ${props.current &&
      css`
        font-weight: 600;
      `}
  `
);

export const GroupIconComponent = styled(GroupIcon)`
  margin-left: ${layout.spacing.xSmall};
`;
export const SortIconComponent = styled(SortIcon)`
  margin-left: ${layout.spacing.xSmall};
`;
